// src/components/admin/AdminPage.jsx
import React from "react";
import AdminGate from "./AdminGate";
import AdminConsole from "./AdminConsole";

export default function AdminPage() {
  return (
    <AdminGate>
      <AdminConsole />
    </AdminGate>
  );
}
